<template>
  <v-dialog
    v-model="dialog"
    max-width="300"
  >
    <v-card>
      <v-card-title>
        Cambiar contraseña
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form ref="form">
          <v-text-field
            v-model="pass_actual"
            label="Contraseña actual"
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'fas fa-eye-slash' : 'fas fa-eye'"
            :rules="[rules.required, rules.min]"
            validate-on-blur
            outlined
            dense
            @click:append="show = !show"
          ></v-text-field>
          <v-text-field
            v-model="pass_nueva"
            label="Contraseña nueva"
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'fas fa-eye-slash' : 'fas fa-eye'"
            :rules="[rules.required, rules.min, rules.igual]"
            validate-on-blur
            outlined
            counter
            dense
            @click:append="show = !show"
          ></v-text-field>
          <v-text-field
            v-model="pass_repetida"
            label="Repetir contraseña"
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'fas fa-eye-slash' : 'fas fa-eye'"
            :rules="[rules.required, rules.min, rules.coincide]"
            validate-on-blur
            outlined
            counter
            dense
            @click:append="show = !show"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-end py-4">
        <v-btn
          color="error"
          @click="dialog = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click="cambiar()"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      pass_actual: '',
      pass_nueva: '',
      pass_repetida: '',
      rules: {
        required: value => !!value || 'Campo requerido',
        min: value => value.length >= 6 || 'Mínimo 6 caracteres',
        coincide: value => value === this.pass_nueva || 'Las contraseñas no coinciden',
        igual: value => value !== this.pass_actual || 'La contraseña nueva no puede ser igual a la actual',
      },
    }
  },
  props: {
    value: Boolean,
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.clear()
    }
  },
  methods: {
    async cambiar () {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true
        await this.$store.dispatch('cambiar_pass', {
          pass_actual: this.pass_actual,
          pass_nueva: this.pass_nueva,
        })
          .then((res) => {
            this.$swal.fire({
              icon: 'success',
              title: res,
            })
            this.dialog = false
          })
          .catch((error) => {
            this.$swal.fire({
              icon: 'error',
              title: 'Error al cambiar la contraseña',
              text: error,
            })
          })
        this.$store.state.loading = false
      }
    },
    clear () {
      this.$refs.form.resetValidation()
      this.show = false
      this.pass_actual = ''
      this.pass_nueva = ''
      this.pass_repetida = ''
    }
  }
}
</script>
